export const locale = {
    lang: 'pl',
    data: {
        'Trainer': 'Trener',
        'Reservation': 'Rezerwacja',
        'Group activity': 'Aktywność grupowa'
    }
};
